import { createFileRoute, useParams } from "@tanstack/react-router";
import { AuditPage } from "../features/audit/pages/audit-page";

export const Route = createFileRoute("/tenants/$tenantId/audit")({
  component: TenantAuditTab,
});

/** The same ledger, narrowed to this roastery: what an operator did here, and nowhere else. */
function TenantAuditTab() {
  const { tenantId } = useParams({ from: "/tenants/$tenantId/audit" });
  return <AuditPage tenantId={tenantId} />;
}
